import React from "react";

import { wrap } from "./RydTestbedWrap";
import { PianoRollBackground } from "../components/widgets/rolls/PianoRollBackground";
import { RydViewport } from "../components/widgets/RydViewport";
import { PianoRollKeybed } from "../components/rolls/PianoKeybed";
import {
    NoteDuration,
    TimeSignature
} from "../model/core";

export function PianoRollBackgroundTestbed() {

    const noteRange = {
        min: 21, // A0
        max: 108, // C8
    };
    const contextFrame = {
        timeSignature : new TimeSignature(4, 4),
    };

    const newNoteDuration = new NoteDuration(1);

    return wrap(<>
        {/* Add your testbed components here */}
        <h1>PianoRollBackground Testbed</h1>
        <h2>bare</h2>
        <PianoRollBackground
            trackId={1}
            noteRange={noteRange}
            timeSignature={contextFrame.timeSignature}
        />
        <h2>viewport</h2>
        <div
            className="piano-roll-content-wrapper" >
            <PianoRollBackground
                trackId={1}
                noteRange={noteRange}
                timeSignature={contextFrame.timeSignature}
            />
        </div>

        <h2>viewport with keybed</h2>
        <RydViewport name="foo">
            <div
                className="piano-roll-content-wrapper" style={{ display: 'inline-block', flexDirection: 'row' }}>

                <PianoRollKeybed
                    noteRange={noteRange}
                />
                <div className="piano-roll-input-layer">
                    <PianoRollBackground
                        trackId={1}
                        noteRange={noteRange}
                        timeSignature={contextFrame.timeSignature}
                    />
                </div>
            </div>
        </RydViewport>
    </>);
}